import { FC, useContext } from "react";

import AuthSubHeader from "../../components/authSubHeader";
import FooterText from "src/components/footerText";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";
import BAAContent from "src/components/baaContent";

import { AuthContext } from "src/context/authContext";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";


const BAAAgreement: FC = (): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);

  return (
    <div className={!isUserAuthorized ? 'guest-page-bg overflow-auto' : 'overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill'}>
        <div className="bg-mist py-2">
            <div className="container-fluid">
                {isUserAuthorized ? (
                    <AuthSubHeader/>
                ) : (
                    <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="white"/>
                )}
            </div>
        </div>
        <div className="container-fluid pt-2 d-flex flex-column flex-fill">
            <div className="mt-4">
                <BAAContent/>
            </div>
        </div>
        <FooterText footerType={isUserAuthorized ? "black" : "white"}/>
    </div>
  );
};

export default BAAAgreement;
